// import { useEffect, useState } from "react";
// import { AllManageStateContainer, Cart, Container } from "./style";
// import OnBoardingPopup from "components/popus/Settings/onboarding";
// import Button from "components/particles/primary-button";
// import { useOnBoarding } from "./useHook";
// import { dispatch, RootState } from "store";
// import { setModalOpened } from "store/user-slice";
// import { useSelector } from "react-redux";

// interface OnBoardingProps {
//   type: String;
// }

// export default function OnBoarding({ type }: OnBoardingProps) {
//   console.log(type, "type");
//   const [data, setData] = useState<any[]>([]);
//   const [dataById, setDataById] = useState<any>(null);
//   const [id, setId] = useState<number>(0);
//   const { onBoardingModalIsOpen } = useSelector(
//     (state: RootState) => state.user
//   );
//   const { getOnBoarding, getOnBoardingById } = useOnBoarding();

//   useEffect(() => {
//     getOnBoarding(setData);
//   }, [type, onBoardingModalIsOpen]);
//   console.log(data, "data");

//   const handleChangeOnboarding = (id: number) => {
//     dispatch(setModalOpened("OnBoarding Screen"));
//     setId(id);
//     if (id) {
//       getOnBoardingById(id, setDataById);
//     }
//   };

//   return (
//     <Container>
//       <div className="title">
//         <h1>{type}</h1>
//         {data?.length >= 6 ? null : (
//           <Button
//             title={`Add ${type}`}
//             onclick={() => handleChangeOnboarding(0)}
//             width="30rem"
//             fill="true"
//           />
//         )}
//       </div>

//       <AllManageStateContainer>
//         {data.map((onboarding) => (
//           <Cart key={onboarding?.id}>
//             <div className="banner-img-title">
//               <div>
//                 <img
//                   src={onboarding?.image || "https://picsum.photos/200"}
//                   alt="img"
//                 />
//               </div>
//               <div className="banner-title">
//                 <span>Text 1</span>
//                 <h1>{onboarding?.text1}</h1>
//                 <span>Text 2</span>
//                 <h1>{onboarding?.text2}</h1>
//                 <span>Text 3</span>
//                 <h1>{onboarding?.text3}</h1>
//               </div>
//             </div>
//             <Button
//               title="Edit"
//               width="11.2rem"
//               fill="true"
//               onclick={() => handleChangeOnboarding(onboarding?.id)}
//               backgroundcolor="var(--medium-black)"
//             />
//           </Cart>
//         ))}
//       </AllManageStateContainer>

//       {onBoardingModalIsOpen ? (
//         <OnBoardingPopup data={dataById} id={id} type={type} />
//       ) : null}
//     </Container>
//   );
// }

import { useEffect, useState } from "react";
import { AllManageStateContainer, Cart, Container } from "./style";
import OnBoardingPopup from "components/popus/Settings/onboarding";
import Button from "components/particles/primary-button";
import { useOnBoarding } from "./useHook";
import { dispatch, RootState } from "store";
import { setModalOpened } from "store/user-slice";
import { useSelector } from "react-redux";

interface OnBoardingProps {
  type: string;
}

export default function OnBoarding({ type }: OnBoardingProps) {
  const [data, setData] = useState<any[]>([]);
  const [dataById, setDataById] = useState<any>(null);
  const [id, setId] = useState<number>(0);
  const { onBoardingModalIsOpen } = useSelector(
    (state: RootState) => state.user
  );
  const { getOnBoarding, getOnBoardingById } = useOnBoarding();

  useEffect(() => {
    getOnBoarding(setData);
  }, [type, onBoardingModalIsOpen]);

  const handleChangeOnboarding = (id: number) => {
    dispatch(setModalOpened("OnBoarding Screen"));
    setId(id);
    setDataById(null);
    if (id) {
      getOnBoardingById(id, setDataById);
    }
  };

  // Filter data based on the current type tab
  const filteredData = data.filter((item) => {
    if (type === "Onboarding Screen") return item.isOnBoarding;
    if (type === "HomeCook Onboarding Screen") return item.isHomeCook;
    if (type === "SignUp Onboarding Screen") return item.isSignup;
    return false;
  });
  const maxItemAllowed =
    type === "Onboarding Screen"
      ? 4
      : type === "HomeCook Onboarding Screen"
      ? 1
      : type === "SignUp Onboarding Screen"
      ? 1
      : 0;
  return (
    <Container>
      <div className="title">
        <h1>{type}</h1>
        {filteredData?.length >= maxItemAllowed ? null : (
          <Button
            title={`Add ${type}`}
            onclick={() => handleChangeOnboarding(0)}
            width="30rem"
            fill="true"
          />
        )}
      </div>

      <AllManageStateContainer>
        {filteredData.map((onboarding) => (
          <Cart key={onboarding?.id}>
            <div className="banner-img-title">
              <div>
                <img
                  src={onboarding?.image || "https://picsum.photos/200"}
                  alt="img"
                />
              </div>
              <div className="banner-title">
                <span>Text 1</span>
                <h1>{onboarding?.text1}</h1>
                <span>Text 2</span>
                <h1>{onboarding?.text2}</h1>
                <span>Text 3</span>
                <h1>{onboarding?.text3}</h1>
              </div>
            </div>
            <Button
              title="Update"
              width="11.2rem"
              fill="true"
              onclick={() => handleChangeOnboarding(onboarding?.id)}
              backgroundcolor="var(--secondary)"
            />
          </Cart>
        ))}
      </AllManageStateContainer>

      {onBoardingModalIsOpen ? (
        <OnBoardingPopup
          data={dataById}
          id={id}
          type={type}
          onSuccess={() => getOnBoarding(setData)}
        />
      ) : null}
    </Container>
  );
}
